import React, { useState } from "react";
import data from "../ExperienceData/ExperienceData";
import './experience.css'

export const Experience = () => {

  const [list, setList] = useState(data);

  const filterExperienceCategory = (category) => {
     setList(data.filter((item) => item.company === category))
  }

  return (
    <section className="section experienceSection" id="experience">
      <h1 className="sectionTitle">
        <span style={{ color: "aqua" }}>II. </span>Where I've Worked
      </h1>

      {/* List the companies name  */}
      <div className="mt-5 d-flex experienceContainer flex-row justify-content-start align-items-center">
        <div className="d-flex flex-column justify-content-start mt-5 align-items-center">
          {data.map((item) => {
            return (
              <div key={item.id} className="d-flex flex-row align-items-center">
                <button className="btn my-3" onClick={() => filterExperienceCategory(item.company)}>{item.company}</button>
              </div>
            );
          })}
        </div>

        {list.map((item) => {
          return (
            <article key={item.id} className="w-50 ms-5">
              <h2 style={{color: "aqua", fontSize: "1.4rem"}}>{item.title}</h2>
              <p style={{color: "grey"}}>{item.duration}</p>
              <p style={{color: "white"}}>{item.desc}</p>
            </article>
          )
        })}
      </div>
    </section>
  );
};
